export default __webpack_public_path__ + "static/media/learnAi6Low.16f17cad.jpg";